import React, {useState} from 'react'
import FicheContact from '../../Component/Fiche/FicheContact'
import Insee from '../../Component/Table/insee'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'
import Grid from '@material-ui/core/Grid'
import EurestoDiv from 'EurestoComponents/EurestoDiv/index'
import Modal from 'Components/Modal'

export default (props) => {
  const [entite, setEntite] = useState(props && props.location && props.location.state && props.location.state.entite || 0)
  const [type, setType] = useState(Constants.access.CLIENT)
  const [insee, setInsee] = useState(false)
  const [contact, setContact] = useState(props.contact || {})

  const handleClickNewEntity = (e, t) => _ => {
    if (e === 2) {
      setInsee(true)
    }
    setEntite(e)
    setType(t)
  }

  const onClickInsee = (row) => {
    setInsee(false)
    setContact(row)
  }

  return insee && <Modal open={insee} onClose={() => setInsee(false)}><EurestoDiv
      title={'Recherche dans les données de l\'INSEE'}><Insee
      search={'insee_' + (props.name || '') + User.Entite.get().id}
      onClick={onClickInsee} showSearch/></EurestoDiv></Modal>
    || entite !== 0 && <FicheContact handleSaveContact={props.handleSaveContact}
                                     handleCancelContact={props.handleCancelContact}
                                     typeContact={type}
                                     typeaction="add" typeentite={entite} data={contact} modalHeight={props.modalHeight}/>
    || <Grid container style={{ margin: 0, padding: 10 }} spacing={8} direction="row" justify="center"
             alignItems="center">
      <Grid item style={{ margin: 0, padding: 10 }} xs>
        <EurestoDiv title={'Personne'} style={{ padding: 0, margin: 0, paddingTop: 10 }}>
          <Grid container style={{ margin: 0, padding: 10, cursor: 'pointer' }} spacing={0} direction="column"
                onClick={handleClickNewEntity(1, Constants.access.CLIENT)}
                justify="center"
                alignItems="center">
            <i className="ei-crm_physique"
               style={{ fontSize: 100, color: EurestoColor('EurestoSecondary') }}
               aria-hidden="true"/>
          </Grid>
        </EurestoDiv>
      </Grid>
      <Grid item style={{ margin: 0, padding: 10 }} xs>
        <EurestoDiv title={'Entité'} style={{ padding: 0, margin: 0, paddingTop: 10 }}>
          <Grid container style={{ margin: 0, padding: 10, cursor: 'pointer' }} spacing={0} direction="column"
                onClick={handleClickNewEntity(2, Constants.access.CLIENT)}
                justify="center"
                alignItems="center">
            <i className="ei-crm_morale"
               style={{ fontSize: 100, color: EurestoColor('EurestoSecondary') }}
               aria-hidden="true"/>
          </Grid>
        </EurestoDiv>
      </Grid>
      {User.TypeAccess.get(Constants.access.EURESTO) &&
      <Grid item style={{ margin: 0, padding: 10 }} xs>
        <EurestoDiv title={'Établissement Client'} style={{ padding: 0, margin: 0, paddingTop: 10 }}>
          <Grid container style={{ margin: 0, padding: 10, cursor: 'pointer' }} spacing={0} direction="column"
                onClick={handleClickNewEntity(2, Constants.access.ETABLISSEMENT)}
                justify="center"
                alignItems="center">
            <i className="ei-crm_etablissement"
               style={{ fontSize: 100, color: EurestoColor('EurestoSecondary') }}
               aria-hidden="true"/>
          </Grid>
        </EurestoDiv>
      </Grid>}
      {User.TypeAccess.get(Constants.access.EURESTO) &&
      <Grid item style={{ margin: 0, padding: 10 }} xs>
        <EurestoDiv title={'Groupe'} style={{ padding: 0, margin: 0, paddingTop: 10 }}>
          <Grid container style={{ margin: 0, padding: 10, cursor: 'pointer' }} spacing={0} direction="column"
                onClick={handleClickNewEntity(2, Constants.access.GROUPE)}
                justify="center"
                alignItems="center">
            <i className="ei-crm_groupe"
               style={{ fontSize: 100, color: EurestoColor('EurestoSecondary') }}
               aria-hidden="true"/>
          </Grid>
        </EurestoDiv>
      </Grid>}
    </Grid>

}






// WEBPACK FOOTER //
// ./app/App/Module/CRM/Page/Ajout/index.js